import { render, staticRenderFns } from "./LeafStyledRadioButtons.vue?vue&type=template&id=39355c15&scoped=true&"
import script from "./LeafStyledRadioButtons.vue?vue&type=script&lang=js&"
export * from "./LeafStyledRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./LeafStyledRadioButtons.vue?vue&type=style&index=0&id=39355c15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39355c15",
  null
  
)

export default component.exports